var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 113,
    viewBox: "0 0 175 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 59L59 9L100.5 50.5L126.5 25.5L165.5 65.5",
    stroke: "#333333",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 107.5H164.5",
    stroke: "#333333",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 107V44.5",
    stroke: "#333333",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 106V48.5",
    stroke: "#333333",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5 50.1899V104.5V109.5",
    stroke: "#333333",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.4 63V81.04",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.38 72.02H135.42",
    stroke: "#333333",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 174.5,
    height: 112.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddition);
export default __webpack_public_path__ + "static/media/addition.7623b5a1e0532e3dadb28faede7aea72.svg";
export { ForwardRef as ReactComponent };